/**
 * Helpers
 */
const getCookies = function(name) {
  let value, parts
  if (name) {
    value = "; " + document.cookie
    parts = value.split("; " + name + "=")
    if (parts.length === 2) {
      return parts.pop().split(";").shift()
    }
  } else {
    value = "; " + document.cookie
    parts = value.split("; ")
    parts.shift()
    return parts.map(function (e) {
      let innerElm = e.split('=')
      return {
        name: innerElm[0],
        value: innerElm[1]
      }
    })
  }
}

const getPID = function() {
  let str = null
  let pid = getCookies('brmp')

  if (pid) {
    pid = decodeURIComponent(pid)
    let pidObj = JSON.parse(pid)

    if (pidObj.pid) {
      str = JSON.stringify(pidObj.pid)
    }
  }

  return str
}

const getCookie = (key) => {
  if (!key) { return null; }
  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
}

/**
 * Tagular
 */
((cohesion, beam, undefined) => { // eslint-disable-line no-shadow-restricted-names
  /**
   * Gets closest product box for an element. Looks up and down the DOM tree.
   * @param  {Element} el
   * @return {Element}
   */
  function getProductBox(el) {
    return el.closest('[data-beam-product-viewed]') || el.querySelector('[data-beam-product-viewed]');
  }

  /**
   * Get product ID for a product box.
   * @return {String}
   */
  function getProductId() {
    const wrapper = getProductBox(this);
    if (!wrapper) { return ''; }
    const product = wrapper.dataset.id ? wrapper : wrapper.querySelector('[data-id]');
    return product ? product.dataset.id : '';
  }

  /**
   * Get issuer for a product box.
   * @return {String}
   */
  function getIssuer() {
    const wrapper = getProductBox(this);
    const product = wrapper.dataset.issuerName ? wrapper : wrapper.querySelector('[data-issuer-name]');
    return product ? product.dataset.issuerName : '';
  }

  /**
   * Get category for a product box.
   * @return {String}
   */
  function getCategory() {
    const wrapper = getProductBox(this);
    const product = wrapper.dataset.category ? wrapper : wrapper.querySelector('[data-category]');
    return product ? product.dataset.category : '';
  }

  /**
   * Get current slot position in a product list.
   * @return {Number}
   */
  function getSlotPosition() {
    const pid = getProductId.call(this);
    const slots = [...document.body.querySelectorAll('article[data-beam-product-viewed]')];
    const slotIds = slots.map((s) => getProductId.call(s));
    return Math.max(slotIds.indexOf(pid), 0) + 1;
  }

  /**
   * Get issuer for a product box.
   * @return {String}
   */
  function getProductTitle() {
    const wrapper = getProductBox(this);
    const product = wrapper.dataset.name ? wrapper : wrapper.querySelector('[data-name]');
    return product ? product.dataset.name : '';
  }

  /**
   * Get outbound url
   * @return {String}
   */
  function getOutboundUrl() {
    const wrapper = getProductBox(this);
    const product = wrapper.dataset.outboundUrl ? wrapper : wrapper.querySelector('[data-beam-outbound-url]');
    return product ? product.dataset.outboundUrl : '';
  }
/* brc-1061*/
  function getActionOutcome()
  {
    if(this.dataset.beamActionOutcome === "OPEN")
    {
      const parent = this.parentNode.querySelector (`[aria-hidden]`);
      const value = parent.getAttribute('aria-hidden') === 'true' ? "CLOSE" : "OPEN";
      return value ?? "";
    }
    else
    {
      return this.dataset.beamActionOutcome || "APPLY";
    }
  }
  function getActiveCategoryPage() {

    // Finding category for specific pages
    const wrapper = window.location.pathname;
    switch (wrapper) {
      case '/credit-cards/':
        return 'FEATURED CARD';
      case '/credit-cards/todays-best-credit-cards/':
        return 'BEST CARD';
    }

    let selectedOption = wrapper.slice(1, -1).replace('-', ' ').toUpperCase();
    selectedOption = selectedOption.includes('CREDIT CARDS') ? 'PDP' : selectedOption;
    return selectedOption || '';
  }

  /**
   * Get Beam parameters from the current element or one of its parent elements.
   * @return {String}
   */
  function getBeamParams(value) {
    // Get Beam parameter from current element's attributes
    const attribute = this.getAttribute(`data-beam-${value}`);

    if (attribute) {
      return attribute;
    }

    // Otherwise, try to find a Beam parameter from one of its parent elements
    const parent = this.closest(`[data-beam-${value}`);

    // If the parent has an attribute return it, otherwise return an empty string
    return parent ? parent.getAttribute(`data-beam-${value}`) : '';
  }

  function getElementPosition() {
    let position = getBeamParams.call(this, 'position');

    // Most of the time, position will be a string that converts in to a Number cleanly
    // Sometimes we want to pass the position back as a string describing the element
    // ex: describing section a nav element is in, 'COMPARE BY ISSUER'
    if (position && !isNaN(position)) {
      position = Number(position);
    }

    return position;
  }

  const config = {
    // Generic Selectors
    // ---------------------------------------------------------------------

    // Product Boxes
    // ---------------------------------------------------------------------
    // Product Viewed
    '[data-beam-product-viewed]': {
      '@type': 'ProductViewed',
      product: {
        brand() {
          return getBeamParams.call(this, 'issuer-name') || getIssuer.call(this);
        },
        category() {
          return getBeamParams.call(this, 'category') || getCategory.call(this);
        },
        location() {
          return getBeamParams.call(this, 'location') || 'GRID';
        },
        name() {
          return getBeamParams.call(this, 'name') || getProductTitle.call(this);
        },
        position() {
          return getElementPosition.call(this) || getSlotPosition.call(this);
        },
        productId() {
          return getBeamParams.call(this, 'id') || getProductId.call(this);
        },
        text() {
          return getBeamParams.call(this, 'text') || '';
        },
        variant() {
          return getBeamParams.call(this, 'variant') || 'SLOT';
        },
        formatType() {
          return getBeamParams.call(this, 'format-type') || '';
        },
        pageId: 'var.exitPageId',
      },
    },
    // Product Clicked
    '[data-beam-product-clicked]': {
      data: {
        '@type': 'ProductClicked',
        product: {
          brand() {
            return getBeamParams.call(this, 'brand') || getIssuer.call(this);
          },
          category() {
            return getBeamParams.call(this, 'category') || _BeamVariables.category; // Backwards compatible
          },
          location() {
            return getBeamParams.call(this, 'location') || 'GRID';
          },
          name() {
            return getBeamParams.call(this, 'name') || getProductTitle.call(this);
          },
          position() {
            return Number(getBeamParams.call(this, 'position')) || getSlotPosition.call(this);
          },
          productId() {
            return getBeamParams.call(this, 'product-id') || getProductId.call(this);
          },
          text() {
            return getBeamParams.call(this, 'text') || this.innerText;
          },
          variant() {
            return getBeamParams.call(this, 'variant') || 'BUTTON';
          },
          pageId: 'var.exitPageId',
        },
        actionOutcome() {
          return  getActionOutcome.call(this);
        },
        outboundUrl() {
          return getBeamParams.call(this, 'outbound-url') || getOutboundUrl.call(this);;
        },
        correlationId: 'var.correlation_id',
      },
      settings: {
        addProductViewed: false,
      },
    },
    // Element Viewed
    '[data-beam-element-viewed]': {
      '@type': 'ElementViewed',
      webElement: {
        elementType() {
          return this.dataset.beamElementType || 'BUTTON';
        },
        location() {
          return this.dataset.beamLocation || 'GRID';
        },
        position() {
          return getBeamParams.call(this, 'position') || getSlotPosition.call(this);
        },
        text() {
          return this.dataset.beamText || this.innerText;
        },
        name() {
          return this.dataset.beamName || '';
        },
      },
      actionOutcome() {
        return this.dataset.beamActionOutcome || 'INTERNALLINK';
      },
    },
    // Element Clicked
    '[data-beam-element-clicked]': {
      '@type': 'ElementClicked',
      webElement: {
        elementType() {
          return getBeamParams.call(this, 'element-type') || 'BUTTON';
        },
        location() {
          return getBeamParams.call(this, 'location') || 'GRID';
        },
        position() {
          return getElementPosition.call(this) || '';
        },
        text() {
          return getBeamParams.call(this, 'text') || this.innerText;
        },
        name() {
          return getBeamParams.call(this, 'name') || '';
        },
      },
      actionOutcome() {
        return this.dataset.beamActionOutcome || 'INTERNALLINK';
      },
      outboundUrl() {
        return getBeamParams.call(this, 'outbound-url') || getOutboundUrl.call(this);
      },
    },

    // @TODO @CARDS remove this and add link to product-boxes/editors-take.blade.php
    // Element Clicked for Editors Take Link
    '.cc-product-box__editors-take a:last-of-type': {
      '@type': 'ProductClicked',
      product: {
        brand() {
          return getBeamParams.call(this, 'brand') || getIssuer.call(this);
        },
        category() {
          return getBeamParams.call(this, 'category') || getCategory.call(this);
        },
        location() {
          return 'GRID';
        },
        name() {
          return ( (getBeamParams.call(this, 'name') ?? '').toLowerCase() || getProductTitle.call(this));
        },
        position() {
          return Number(getBeamParams.call(this, 'position')) || getSlotPosition.call(this);
        },
        productId() {
          return getBeamParams.call(this, 'product-id') || getProductId.call(this);
        },
        text() {
          return this.innerText;
        },
        variant() {
          return 'VIEW DETAILS';
        },
      },
      actionOutcome() {
        return 'INTERNALLINK';
      },
      outboundUrl() {
        return getBeamParams.call(this, 'outbound-url') || this.getAttribute('href');
      },
    },
  };


  function start() {
    if (cohesion === undefined) return;

    cohesion('ready', () => {
      const {
        anonymousId,
        instanceId,
        sessionId,
        tenantId,
      } = window._Cohesion;

      // Push Cohesion data to GTM
      if (dataLayer) {
        dataLayer.push({
          event: 'cohesion',
          anonymousId,
          instanceId,
          sessionId,
          tenantId,
        });
      }

      if (beam === undefined) return;

      // Bind events
      beam.load(config, window._BeamVariables);

      // Re-init on `cc:domUpdated`
      document.body.addEventListener('cc:domUpdated', beam.reload);

      // Add correlation ID to known vars
      window.addEventListener('cohesion_correlation_id', (event, correlation_id) => {
        beam.vars({ correlation_id });
      });
    });
  }

  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }

})(window.cohesion, window._Beam);


/**
 * ProductClicked Event and Link Attribution
 * @TODO: Legacy, switch to just using beam library if possible
 */
function addAttributionToApplyButtons() {
  let buttons = document.body.querySelectorAll('a[data-track-click="creditcard.apply"], button[data-track-click="creditcard.apply"]');
  let purchaseID = null;

  const generateNewPurchaseID = function() {
    purchaseID = Math.round(Math.random() * 10000000).toString() + new Date().getTime()
    window.purchaseId = purchaseID
    return purchaseID
  }

  const getUrlParameter = function(name) {
    let url = window.location.href
    name = name.replace(/[\[\]]/g, '\\$&')

    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    let results = regex.exec(url)

    if (!results) {
      return null
    }

    if (!results[2]) {
      return ''
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  const generateUniqueId = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }

  const generateTID = function(categoryId) {
    let edic = getUrlParameter('ed_ic') || ''
    let pidObj = JSON.parse(getPID() || '[]')
    let pid = getUrlParameter('pid')
    if (!pid && pidObj) {
      pid = pidObj['p']
    }

    let catString = categoryId ? `|${categoryId}` : ''

    return `${edic}${catString}|${pid}|2|${generateUniqueId()}`
  }

  for (let i = 0; i < buttons.length; i++) {
    let button = buttons[i];
    let { category, categoryId, link, location, productId, variant, brand, text, outboundUrl } = button.dataset;
    let advertiserName = (button.dataset.cardVendor || '').toLowerCase();
    let name = (button.dataset.productName || '').toLowerCase();
    let position = parseInt(button.dataset.rank, 10) || 1;
    let tid = generateTID(categoryId);

    if (!link) {
      continue;
    }

    button.addEventListener('click', (e) => {
      e.preventDefault();

      // Pull this value on event, not before.
      let formatType = e.target.dataset.formatType || '';
      let purchaseId = generateNewPurchaseID();
      let landingPageUrl = getCookie('tglr_req') || '';
      landingPageUrl = encodeURIComponent(landingPageUrl);
      let initialReferer = getCookie('tglr_ref') || '';
      initialReferer = encodeURIComponent(initialReferer);

      let redirectTo = `${link}&oid=${purchaseId}&tid=${tid}`;
      redirectTo += `&pos=${position}&c_correlation_id=${purchaseId}`;

      // REV-2956: https://creditcards.atlassian.net/browse/REV-2956
      redirectTo += `&c_landing_page_url=${landingPageUrl}&c_initial_referer=${initialReferer}`;

      if (typeof window._Cohesion !== 'undefined') {
        let { anonymousId, instanceId, sessionId, tenantId } = window._Cohesion;
        redirectTo += `&c_anonymous_id=${anonymousId}&c_instance_id=${instanceId}`;
        redirectTo += `&c_session_id=${sessionId}&c_tenant_id=${tenantId}`;
      }

      // BRC-299 - Add PTV params for Capital One
      let pageId = button.dataset.pageId || '399';
      let featured = button.dataset.featured || '0';
      // Will stay hard-coded for now, possibly dictated by app in the future
      let known = '0';
      let filter = '0' ;
      redirectTo += `&ptv[pageid]=${pageId}&ptv[featured]=${featured}&ptv[known]=${known}&ptv[filter]=${filter}`

      dataLayer.push({
        event: "e_reviewCTA",
        buttonText: text,
        destinationType: "Signup Page",
        advertiserName,
        position,
        purchaseID: purchaseId,
        rateAdvertiser: advertiserName,
        ratePosition: position,
        cardName: name,
        ecommerce: {
          purchase: {
            actionField: { id: purchaseId }
          }
        }
      });

      if (typeof window.tagular !== 'undefined') {
        window.tagular('beam', 'ProductClicked', {
          '@type': 'redventures.ecommerce.v1.ProductClicked',
          product: { category, location, name, productId, position, variant, brand, text, formatType },
          correlationId: purchaseId,
          actionOutcome: 'APPLY',
          outboundUrl: outboundUrl
        });
      }

      let win = window.open(redirectTo);

      try {
        win.focus();
      } catch (e) {
        let wait4me = setTimeout(function () {
          window.location = redirectTo;
        }, 1000);
      }
    }, true);
  }
}

addAttributionToApplyButtons();
document.body.addEventListener('cc:domUpdated', addAttributionToApplyButtons);
